
import "./webCreationPage.css";
import Progress from '../progressBar/Progress';
import SubscriptionContextProvider from "../../../contextApi/SubscriptionContext";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Chatbot from "../../ai/Chatbot.jsx";

export default function WebCreationPage({childForm, subject, toPath}) {
    const nav = useNavigate();
    useEffect(()=>{window.scrollTo({top:0,behavior:"smooth"})},[])
    return (
        <SubscriptionContextProvider>
            <div className="webCreationPage" dir='rtl'>
                <div className="goBackArrow" onClick={()=>{nav(toPath)}}></div>
                <h1>ברוכים הבאים לWebingo!</h1>
                <h2>{subject}</h2>
                <Progress/>
                {childForm}
                <Chatbot/>
            </div>
        </SubscriptionContextProvider>
    )
}
